import { WorkloadClient } from '@internal/workload-api-helper';
import { ApiValidation, ValidationResult } from '../types';

export const isValueDefined = (value?: any) =>
  value !== undefined && value !== null;

export const isOkayResponse = (response?: Response) => response?.ok === true;

export const objectIsEmpty = (object: Object) =>
  !object || Object.keys(object).length === 0;

export const isResponseCodeAcceptable = (responseCode?: number) =>
  responseCode !== undefined && responseCode > 100 && responseCode < 205;

export async function validateQuestion(
  fieldName: string,
  fieldValue: string,
  apiValidation: ApiValidation,
  workloadClient: WorkloadClient,
  nonGovernanceValidation?: boolean,
  isReadyForApiValidation?: boolean,
): Promise<string | true> {
  if (isReadyForApiValidation === false) {
    return true;
  }

  let contextValues = {};
  if (nonGovernanceValidation) {
    contextValues = {
      ...apiValidation.form.getValues(),
    };
  } else {
    contextValues = {
      ...apiValidation.form.getValues(),
      governance_group_membership: apiValidation.form
        .getValues()
        .governance_group_membership?.map((obj: { value: any }) => obj.value),
    };
  }

  const payload = {
    field_name: fieldName,
    field_value: fieldValue,
    context: contextValues,
  };

  const response = await workloadClient.apiFetch(
    'workloads/validation',
    'POST',
    payload,
  );

  if (response.status === 400) {
    const data: ValidationResult = await response.json();
    let errorMessage = '';

    if (data.failures.length > 0) {
      data.failures.forEach(failure => {
        failure.reasons.forEach(reason => (errorMessage += `${reason}. `));
      });
      return errorMessage;
    }
    return true;
  } else if (response.status >= 400) {
    return 'An error occurred calling the validation API';
  }
  return true;
}
